import styled from "styled-components";
import { useStoryBibleStore } from "../../../../stores/storyBibleStore";
import InlineSVG from "react-inlinesvg";
import IconButton from "../../../IconButton";
import { themeVariables } from "src/themeVariables";

const HeaderContainer = styled.div`
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 20px;
  .title {
    svg {
      width: 30px;
      height: 30px;
      path {
        fill: ${themeVariables.grey0};
      }
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    font-size: 20px;
    font-weight: 500;
  }
`;

function Header() {
  const setProseGeneratorActive = useStoryBibleStore((state) => state.setProseGeneratorActive);
  return (
    <HeaderContainer>
      <div className="title">
        <InlineSVG
          aria-hidden="true"
          src={"/assets/story-bible/generator.svg"}
        />
        Draft
      </div>

      <IconButton
        onClick={() => setProseGeneratorActive(false)}
        src="/assets/close.svg"
        ariaLabel="Close Draft"
        hoverTipText="Hide Draft"
        iconSize={32}
      />
    </HeaderContainer>
  );
}

export default Header;
